export default __webpack_public_path__ + "static/media/pennywise.56ab91e2.svg";